// https://vuex.vuejs.org/en/state.html
var ready = false
export default {
  //
  connected: false,
  ready: ready
}
